<template>
  <MRow>
    <MCol :size="12">
      <FlotoForm v-if="isEditing" layout="vertical" @submit="handleSubmit">
        <MRow>
          <MCol :size="3" class="m-2">
            <FlotoFormItem
              id="enable-geolocation"
              :label="$tc('enable_geolocation')"
              :placeholder="$tc('enable_geolocation')"
              rules="required"
            >
              <MRadioGroup
                v-model="formData.geoLocationEnable"
                :options="enableGeolocationOptions"
                :disabled="disabled"
                @change="handleGeoLocationEnableChange"
              />
            </FlotoFormItem>
          </MCol>
        </MRow>
        <MRow v-if="formData.geoLocationEnable">
          <MCol :size="3" class="m-2">
            <FlotoFormItem
              id="geolocation-preference"
              :label="$tc('geolocation_preference')"
              :placeholder="$tc('geolocation_preference')"
              rules="required"
            >
              <MRadioGroup
                v-model="formData.geoLocationPreferenceType"
                :options="locationPreferenceOptions"
                :disabled="disabled"
              />
            </FlotoFormItem>
          </MCol>
        </MRow>
        <MRow v-if="formData.geoLocationEnable">
          <MCol :size="6">
            <MRow>
              <MCol :size="6">
                <FlotoFormItem
                  id="default-asset-latitude"
                  v-model="formData.defaultLatitude"
                  :label="`${$tc('latitude')}`"
                  :placeholder="`${$tc('latitude')}`"
                  rules="latitude"
                />
              </MCol>
              <MCol :size="6">
                <FlotoFormItem
                  id="default-asset-longitude"
                  v-model="formData.defaultLongitude"
                  :label="`${$tc('longitude')}`"
                  :placeholder="`${$tc('longitude')}`"
                  rules="longitude"
                />
              </MCol>
            </MRow>
          </MCol>
          <!-- <MCol :size="3">
            <div class="flex">
              <FlotoFormItem
                id="default-asset-latitude"
                v-model="formData.defaultLatitude"
                :label="`${$tc('latitude')}`"
                :placeholder="`${$tc('latitude')}`"
                rules="latitude"
              />
              <FlotoFormItem
                id="default-asset-longitude"
                v-model="formData.defaultLongitude"
                :label="`${$tc('longitude')}`"
                :placeholder="`${$tc('longitude')}`"
                rules="longitude"
              />
            </div>
          </MCol> -->
          <MCol :size="6">
            <FlotoFormItem
              id="locate-on-map"
              :label="$tc('locate_on_map')"
              :placeholder="$tc('locate_on_map')"
            >
              <GeolocationDrawer
                allow-location-selection
                :allow-tooltip="true"
                :allow-search="true"
                :coordinates="getCoordinates"
                @getGeolocationDetails="handleAppendGeolocationData"
              >
                <template v-slot:trigger>
                  <MButton
                    shape="circle"
                    variant="neutral-lighter"
                    :shadow="false"
                    class="mx-2"
                  >
                    <MIcon name="map-marker-alt" />
                  </MButton>
                </template>
              </GeolocationDrawer>
            </FlotoFormItem>
          </MCol>
        </MRow>
        <template v-slot:submit>
          <MDivider />
          <div class="text-right">
            <MButton type="submit" :loading="processing" class="mr-2">
              {{ $t('update') }}
            </MButton>
            <MButton class="mr-2" variant="default" @click="cancelEditing">
              {{ $t('cancel') }}
            </MButton>
          </div>
        </template>
      </FlotoForm>
      <GeolocationDetailItem
        v-else
        :geolocation-detail-info="resource"
        allow-edit
        allow-delete
        :disabled="disabled"
        @edit="isEditing = true"
      />
    </MCol>
  </MRow>
</template>
<script>
// import CloneDeep from 'lodash/cloneDeep'
// import Pick from 'lodash/pick'
import GeolocationDrawer from '@src/components/geolocation-drawer.vue'
import { updateApi } from '../asset-api'
import GeolocationDetailItem from './geolocation-detail-item.vue'
import {
  enableGeolocationOptions,
  locationPreferenceOptions,
} from '../helpers/option-map'
export default {
  name: 'GeolocationDetail',
  components: { GeolocationDetailItem, GeolocationDrawer },
  props: {
    resourceId: { type: Number, default: undefined },
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
    disabled: { type: Boolean, default: false },
    assetConfigInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    moduleName: { type: String, required: true },
  },
  data() {
    this.enableGeolocationOptions = enableGeolocationOptions()
    this.locationPreferenceOptions = locationPreferenceOptions()
    return {
      processing: false,
      isEditing: false,
      formData: {
        defaultLatitude: this.resource.defaultLatitude || '',
        defaultLongitude: this.resource.defaultLongitude || '',
        geoLocationPreferenceType: this.resource.geoLocationPreferenceType,
        geoLocationEnable: this.resource.geoLocationEnable,
        defaultLocationName: this.resource.defaultLocationName || '',
      },
      geolocationDetails: {},
      address: '',
    }
  },
  computed: {
    getCoordinates() {
      const coordinates = {
        lat: this.formData.defaultLatitude || '',
        lng: this.formData.defaultLongitude || '',
      }
      return this.formData.defaultLatitude && this.formData.defaultLongitude
        ? coordinates
        : {}
    },
  },
  methods: {
    cancelEditing() {
      this.isEditing = false
      this.processing = false
      this.formData = {
        defaultLatitude: this.resource.defaultLatitude || '',
        defaultLongitude: this.resource.defaultLongitude || '',
        defaultLocationName: this.resource.defaultLocationName || '',
        geoLocationPreferenceType:
          this.resource.geoLocationPreferenceType || 'default',
        geoLocationEnable: this.resource.geoLocationEnable,
      }
    },
    handleSubmit() {
      this.processing = true
      const lat = this.formData.defaultLatitude
      const lng = this.formData.defaultLongitude
      fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
      )
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          return updateApi(this.moduleName, {
            ...this.formData,
            id: this.resource.id,
            type: this.resource.type,
            defaultLocationName: data.display_name,
          }).then((response) => {
            this.processing = false
            this.isEditing = false
            this.geolocationDetails = response
            this.$emit('refresh', ['geolocation'])
          })
        })
        .catch((error) => {
          this.catchUserPosition = error
          this.processing = false
        })
    },
    handleAppendGeolocationData(currentPosition) {
      this.formData = {
        ...this.formData,
        defaultLongitude: currentPosition.longitude || '',
        defaultLatitude: currentPosition.latitude || '',
      }
    },
    handleGeoLocationEnableChange() {
      if (!this.formData.geoLocationEnable) {
        this.formData = {
          ...this.formData,
        }
      }
    },
  },
}
</script>
